import { BEMBlock } from 'helpers/classnames';
import { Toggle } from 'palette/Toggle';
import ActivateDeals from '@common/ActivateDeals/components/ActivateDeals';
import { FiltersList } from '@common/Filters/components/FiltersList';
import {
    ActiveFilters, FiltersListSeoBlock, FiltersPanel
} from '@common/Filters/containers';
import { useConfig } from '@common/Hooks/useConfig';
import { useTranslation } from '@common/Hooks/useTranslation';
import { useListingTop } from '@common/Listing/hooks';
import { SPONSORED_PRODUCT_MODAL_ID } from '@common/Product/Sponsor/constants/modalIds';
import { SponsoredProductsModal } from '@common/Product/Sponsor/SponsoredProductsModal';
import { SubCategories } from '@common/SubCategories/containers/SubCategories';
import { isFeatureActive } from '@helpers/index';
import { ListingTopInfo } from './ListingTopInfo';
import ProductsCountInfo from './ProductsCountInfo';
import '../styles/ListingTop.scss';

export default function ListingTop({
    navigation,
    categoryMenu,
    categoryName,
    filters,
    hasOrderFilter,
    isAlt2Listing
}) {
    const [block, BEMElement] = BEMBlock('listing-top');
    const translate = useTranslation();
    const config = useConfig();

    const { theme, modelImageMode, onToggleChange } = useListingTop();

    return (
        <div className={block}>
            <ActivateDeals />
            <FiltersList
                filters={filters}
                hasOrderFilter={hasOrderFilter}
                theme={theme}
            />
            <ActiveFilters />
            <div className={BEMElement('sub-categories-box')}>
                {categoryMenu?.children?.length > 0
                    && (
                        <SubCategories
                            customClass={BEMElement('subcategories')}
                            subcategories={categoryMenu}
                        />
                    )}
                <FiltersPanel />
                <FiltersListSeoBlock
                    filters={filters}
                    navigation={navigation}
                />
            </div>
            <div className={BEMElement('bottom-box')}>
                <div className={BEMElement('product-info-container')}>
                    <ProductsCountInfo categoryName={categoryName} />
                    {isFeatureActive('PLT-36479-sponsored-products', config) && (
                        <SponsoredProductsModal
                            className={BEMElement('sponsored-icon')}
                            id={SPONSORED_PRODUCT_MODAL_ID.listingTop}
                            linkLabel={translate('listing_products.tooltip_link')}
                            linkURL={translate('listing_products.tooltip_url')}
                            message={translate('listing_products.tooltip_text')}
                            title={translate('listing_products.tooltip_title')}
                        />
                    )}
                </div>
                <ListingTopInfo
                    isAlt2Listing={isAlt2Listing}
                    theme={theme}
                />
            </div>
            {isFeatureActive('PLT-50092_toggle_switch_product_model_images', config) && (
                <div className={BEMElement('switch-toggle')}>
                    <div className={BEMElement('switch-toggle-inner-box')}>
                        <Toggle
                            id="Model images"
                            isChecked={modelImageMode}
                            label={translate('listing.all.modelImages')}
                            value={modelImageMode}
                            variant="switch"
                            onChange={onToggleChange}
                        />
                    </div>
                </div>
            )}
        </div>
    );
}
